<template>
  <certificateDetail
    :listData="officialData"
    :title="$t('1860')"
    :but="but"
    :authority="authority"
    @handleItem="handleItem"
  ></certificateDetail>
</template>

<script>
import certificateDetail from '../compontent/certificate-detail'

export default {
  components: { certificateDetail },
  data() {
    return {
      officialData: [
        // 列表配置数据
        {
          list: [
            {
              // 在职证明
              icon: require('@/assets/img/icon-staff1.png'),
              name: this.$t('certificate_staff_1'), // 模块名称
              txt: this.$t('certificate_staff_2'), // 模块介绍
              path: '/certificate/detail-staff/1', // 页面对应路径
              goPath: '/certificate/staff' // 返回路径
            },
            {
              // 工资证明
              icon: require('@/assets/img/icon-staff2.png'),
              name: this.$t('certificate_staff_3'),
              txt: this.$t('certificate_staff_4'),
              path: '/certificate/detail-staff/2',
              goPath: '/certificate/staff'
            },
            {
              // 就业证明
              icon: require('@/assets/img/icon-staff3.png'),
              name: this.$t('certificate_staff_5'),
              txt: this.$t('certificate_staff_6'),
              path: '/certificate/detail-staff/3',
              goPath: '/certificate/staff'
            },
            {
              // 50 tawi
              icon: require('@/assets/img/icon-staff4.png'),
              name: this.$t('certificate_staff_7'),
              txt: this.$t('certificate_staff_8'),
              path: '/certificate/detail-staff/4',
              goPath: '/certificate/staff'
            }
          ]
        }
      ],
      but: {
        history: {
          label: this.$t('certificate_staff_9'),
          path: '/certificate/history-staff',
          goPath: '/certificate/staff'
        }, // 历史记录
        timing: {
          label: this.$t('certificate_staff_10'),
          path: '/certificate/timing-staff',
          goPath: '/certificate/staff'
        } // 定时发送
      },
      authority: {
        export: this.$p('menu.certificate.staff.export'),
        edit: this.$p('menu.certificate.staff.edit')
        // delete: this.$p('menu.certificate.staff.delete'),
        // setting: this.$p('menu.certificate.staff.setting'),
      },
      itemData: { cItem: {} }
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.title = this.itemData.cItem.name || to.meta.title
    next()
  },
  methods: {
    handleItem(item) {
      this.itemData = item
      this.$router.push(item.cItem.path)
    }
  }
}
</script>

<style lang="scss" scoped></style>
